module.exports = __webpack_public_path__ + "static/media/me-about.c7f17d91.jpeg";